module.exports = __webpack_public_path__ + "img/telemedicine3.d0b341ab.jpg";